import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {Permission} from '../../types/permission-group/permission';
import {logoutAction} from '../rootAction';

export interface projectPermissionState {
  permissionsByProject: Record<string, Permission[]|undefined>;
}

const initialState: projectPermissionState = {
  permissionsByProject: {},
};

const projectPermissionsSlice = createSlice({
  name: 'projectPermissions',
  initialState,
  reducers: {
    setPermissionsByProject(
      state,
      action: PayloadAction<{projectId: string; permissions: Permission[]}>
    ) {
      state.permissionsByProject[action.payload.projectId] =
        action.payload.permissions;
    },
    resetPermissionsByProject: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => {
      return initialState;
    });
  },
});

export const {setPermissionsByProject, resetPermissionsByProject} =
  projectPermissionsSlice.actions;

export default projectPermissionsSlice.reducer;
